import React, { useEffect, useRef, useState } from 'react';
import '../styles/ChallengeModal.css';
import ChallengeForm from './ChallengeForm';
import ChallengePreview from './ChallengePreview';

export default function ChallengeModal({ isOpen, initialData, onClose, onSaved, onPreviewChange }) {
  const modalRef = useRef(null);
  const contentRef = useRef(null);
  const [livePreview, setLivePreview] = useState(initialData || {});

  useEffect(() => {
    if (isOpen) {
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
      // Focus trap
      setTimeout(() => contentRef.current?.focus(), 100);
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [isOpen, onClose]);

  const handleBackdropClick = (e) => {
    if (e.target === modalRef.current) {
      onClose();
    }
  };

  const handlePreviewChange = (data) => {
    setLivePreview(data);
    onPreviewChange && onPreviewChange(data);
  };

  if (!isOpen) return null;

  return (
    <div className="cm-overlay" ref={modalRef} onClick={handleBackdropClick}>
      <div className="cm-modal" ref={contentRef} role="dialog" aria-modal="true">
        <div className="cm-container">
          <div className="cm-left">
            <ChallengeForm
              initialData={initialData || {}}
              onSaved={(data) => {
                onSaved && onSaved(data);
                onClose();
              }}
              onCancel={onClose}
              onPreviewChange={handlePreviewChange}
            />
          </div>
          <div className="cm-right">
            <div className="cm-preview-sticky">
              <ChallengePreview data={livePreview} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
